import React, { useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { errorNotify, successNotify } from "../../Services/Notification";
import { Helmet } from "react-helmet";
import MirageLoader from "../../components/ui/pageLoader/MirageLoader";

const ForgetPassword = () => {
  const currentUrl = window.location.href;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [user, setuser] = useState({
    email: null,
    phone: null,
  });

  const orgSchemeData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "I4invest",
    url: "https://i4invest.in/",
    logo: "https://i4invest.in/images/logo.png",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91-9769699957",
      contactType: "customer service",
      contactOption: "TollFree",
      areaServed: "IN",
      availableLanguage: "en",
    },
  };

  // forget input form
  const [forgetEmailOrPhone, setForgetEmailOrPhone] = useState("");
  const [handleButton, setHandleButton] = useState({});

  // sendotp
  const sendOtp = async (url) => {
    setHandleButton((prev) => ({ ...prev, enable: false, loader: true }));
    await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL + url,
      data: {
        email: user.email,
        phone: user.phone,
      },
    })
      .then(async (response) => {
        if (response.data.status_code === 200) {
          if (response.data.data.email !== null) {
            dispatch({
              type: "setForgetOtp",
              payload: {
                otp_id: response.data.data.email.otp_id,
                username: user.email,
              },
            });
            successNotify(response.data.message);
            navigate("/forget-password-otp", {
              state: {
                payload: {
                  email: user.email,
                  phone: user.phone,
                },
              },
            });
          } else if (response.data.data.phone != null) {
            dispatch({
              type: "setForgetOtp",
              payload: {
                otp_id: response.data.data.phone.otp_id,
                username: user.phone,
                verified: false,
              },
            });
            successNotify(response.data.message);
            navigate("/forget-password-otp", {
              state: {
                payload: {
                  email: user.email,
                  phone: user.phone,
                },
              },
            });
          } else {
            successNotify(response.data.msg);
          }
        } else if (response.data.status === 400) {
          errorNotify(
            `This ${
              user?.email ? "email address" : "phone number"
            } isn’t associated with an account`,
          );
          setHandleButton((prev) => ({ ...prev, enable: true, loader: false }));
        } else if (response.data.message === "username doest not exists") {
          errorNotify(
            `This ${
              user?.email ? "email address" : "phone number"
            } isn’t associated with an account`,
          );
          setHandleButton((prev) => ({ ...prev, enable: true, loader: false }));
        } else {
          errorNotify(response.data.message);
          setHandleButton((prev) => ({ ...prev, enable: true, loader: false }));
        }
      })
      .catch((error) => {
        setHandleButton((prev) => ({ ...prev, enable: true, loader: false }));
      });
  };

  const forgetInputChange = (e) => {
    const value = e.target.value;
    setForgetEmailOrPhone(value);

    if (/^\d{10}$/.test(value)) {
      setuser({
        email: null,
        phone: value,
      });
      setHandleButton((prev) => ({ ...prev, enable: true, loader: false }));
    } else if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
      setuser({
        email: value,
        phone: null,
      });
      setHandleButton((prev) => ({ ...prev, enable: true, loader: false }));
    } else {
      setuser({
        email: "",
        phone: "",
      });
      setHandleButton((prev) => ({ ...prev, enable: false, loader: false }));

    }
  };
  const forgetHandleSubmit = (e) => {
    e.preventDefault();
    if (user.email !== null || user.phone !== null) {
      sendOtp("api/forget-send-otp");
    }
  };

  return (
    <div className="w-full justify-between bg-[#ffffff] px-1 pb-[80px] pt-[130px] md:flex">
      <Helmet>
        <link rel="canonical" href={currentUrl} />
        <title>Forgot Password | I4Invest</title>
        <meta
          name="description"
          content="I4Invest offers top portfolio management software for advisors and investors. Track and manage investments with India’s best mutual fund portfolio tracker app. Call us!"
        />
        <meta
          property="og:image"
          content="https://i4invest.in/logo_i4invest-01.png"
        />
        <meta name="robots" content="index, follow" />
        <script type="application/ld+json">
          {JSON.stringify(orgSchemeData)}
        </script>
      </Helmet>
      <div>
        <div className="mx-auto max-w-[1400px] px-[16px] md:px-0">
          <div className="flex items-center justify-start gap-[25px] md:gap-[45px]">
            <img
              className="w-full max-w-[35px] max-md:hidden"
              src="images/Back-Arrow-btn.png"
              alt=""
            />
            <h2 className="font-open text-[20px] font-[700] leading-[30px] text-[#1E1E1E] md:text-[24px] md:leading-[36px]">
              Forgot Password
            </h2>
          </div>
        </div>

        <div className="mx-auto max-w-[1235px] px-[16px] md:ml-[25%] md:px-0">
          <div className="flex flex-wrap items-start justify-between pt-[40px] md:flex-nowrap">
            <div className="w-full md:w-[322px]">
              <form onSubmit={forgetHandleSubmit} action="">
                <p className="w-full font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E] md:w-[260px]">
                  Enter Registered Email Address/ Mobile Number
                </p>
                <div>
                  <input
                    className="mb-4 mt-[12px] w-full rounded-[8px] border border-[#B6B6B6] bg-[#F7F7F7] px-[16px] py-[12px] font-open text-[16px] font-[400] leading-[24px] text-[#999696] outline-0"
                    type="text"
                    placeholder="Enter here"
                    value={forgetEmailOrPhone}
                    onChange={forgetInputChange}
                    autoComplete="off"
                  />
                  {/* {forgetEmailPhoneError && (
                    <span className="error-for">{forgetEmailPhoneError}</span>
                  )} */}
                </div>
                <button
                  className={`mt-[40px] w-full rounded-[6px] bg-pri-clr-orange px-[24px] py-[10px] font-open text-[16px] font-[600] tracking-[0.003px] text-[#ffffff] hover:bg-[#A94829] md:px-[32px] md:py-[13px] ${
                    !handleButton?.enable
                      ? "opacity-[70%]"
                      : ""
                  }`}
                  type="submit"
                  disabled={!handleButton?.enable}
                >
                  {handleButton?.loader ? <MirageLoader /> : "SEND OTP"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className=" my-auto h-fit max-md:mt-[40px] md:mr-[10%]">
        <h2 className="text-center font-open text-[30px] font-[700] uppercase leading-[40px] text-[#231C42] md:text-[40px] md:leading-[60px]">
          Invest{" "}
          <span className="inline-block whitespace-nowrap md:block">
            With Confidence
          </span>
        </h2>
        <p className="mx-auto w-full pt-[10px] text-center font-open text-[14px] font-[600] leading-[24px] text-[#B6B6B6] md:w-[347px]">
          Unlock Your Investment Potential with Precision Portfolio Management
        </p>
        <div>
          <img className="w-full" src="images/Financial-growth.png" alt="" />
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
